import { useState } from "react";

const OPINIONS = [
  {
    name: "深夜吃瓜机",
    tag: "三观炸裂区",
    text: "把那份名单倒着看一遍，反而是没上榜的最有戏。坐等成人吃瓜圈子内幕下一更。",
    meta: "328 人赞同 · 12 分钟前",
    seed: "A",
  },
  {
    name: "只逛不说的观众",
    tag: "好友八卦区",
    text: "这波好友八卦最妙的地方在于：当事人都没下场，热搜却已换了三任主角。",
    meta: "215 人赞同 · 26 分钟前",
    seed: "B",
  },
  {
    name: "饭圈老表",
    tag: "饭圈谈资区",
    text: "控评模板扒出来那刻，我的表情管理直接崩了，妥妥的饭圈谈资教科书。",
    meta: "189 人赞同 · 40 分钟前",
    seed: "C",
  },
];

export default function ReaderVoice() {
  const [val, setVal] = useState("");

  return (
    <section id="comment" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-12">
          {/* leave a take */}
          <div className="lg:col-span-5">
            <p className="text-xs font-semibold tracking-[0.3em] text-primary-700">READER ROOM</p>
            <h3 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              这条瓜，你怎么看？
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              评论区是成人吃瓜饭圈谈资的另一个主战场。留下你的判断，但记得：吃瓜归吃瓜，图个乐，别上头。
            </p>

            <div className="mt-6 rounded-lg border border-foreground-200/60 bg-background-100 p-4">
              <textarea
                value={val}
                onChange={(e) => setVal(e.target.value)}
                maxLength={140}
                rows={4}
                placeholder="说说你的立场，或补一段你手里没发出去的瓜……"
                className="w-full resize-none rounded-md border border-foreground-200/70 bg-background-50 p-3 text-sm outline-none placeholder:text-foreground-400 focus:border-primary-400"
              />
              <div className="mt-2 flex items-center justify-between">
                <span className="text-xs text-foreground-400">
                  <i className="ri-emotion-happy-line mr-1" aria-hidden="true"></i>
                  {val.length}/140
                </span>
                <button
                  type="button"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 hover:bg-primary-600"
                >
                  一键上瓜板
                  <i className="ri-send-plane-line" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <p className="mt-3 text-xs text-foreground-400">
              提示：此处为静态演示页，点击不会真的提交；本站不上头、不站队、不传谣。
            </p>
          </div>

          {/* recent takes */}
          <div className="lg:col-span-7">
            <div className="flex items-center justify-between">
              <h4 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-voiceprint-fill text-primary-600" aria-hidden="true"></i>
                此刻最热的读者留言
              </h4>
              <span className="text-xs text-foreground-500">热评 · 自动排序</span>
            </div>

            <div className="mt-4 space-y-4">
              {OPINIONS.map((o, idx) => (
                <article
                  key={idx}
                  className="rounded-lg border border-foreground-200/60 bg-background-100 p-5"
                >
                  <div className="flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500/15 font-heading text-sm font-black text-accent-800">
                      {o.seed}
                    </span>
                    <div>
                      <p className="text-sm font-bold text-foreground-900">{o.name}</p>
                      <span className="whitespace-nowrap rounded bg-secondary-200/70 px-1.5 py-0.5 text-xs text-secondary-800">
                        {o.tag}
                      </span>
                    </div>
                  </div>
                  <p className="mt-3 text-[15px] leading-relaxed text-foreground-700">{o.text}</p>
                  <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                    <span>{o.meta}</span>
                    <button
                      type="button"
                      className="flex items-center gap-1 whitespace-nowrap hover:text-primary-700"
                    >
                      <i className="ri-thumb-up-line" aria-hidden="true"></i>
                      顶
                    </button>
                    <button
                      type="button"
                      className="flex items-center gap-1 whitespace-nowrap hover:text-primary-700"
                    >
                      <i className="ri-reply-line" aria-hidden="true"></i>
                      回复
                    </button>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}